"use client";

import { InputMethods } from "@/components/fileCoverInput/inputMethods/InputMethods";
import { AudioInputState, UserNoDates } from "@/types/types";

export function FileCoverInput({
  user,
  checkSubscription,
  audioContext,
  audioLengthMinLimitMinutes,
  audioLengthMaxLimitMinutes,
  showRecorder,
  adjustAcoustic,
  showSelectCoverText,
  showCover,
  setInputCover,
  setInputFiles,
  presentation,
  currentAudioLengthS,
  multipleFiles,
  maxMultiAudioLengthMinutes,
  empty,
}: {
  user: UserNoDates | null;
  checkSubscription: boolean;
  audioContext: AudioContext | null;
  audioLengthMinLimitMinutes: number | null;
  audioLengthMaxLimitMinutes: number;
  showRecorder: boolean;
  adjustAcoustic: boolean | null;
  showSelectCoverText: boolean | null;
  showCover: boolean;
  setInputCover: AudioInputState["setInputCover"] | null;
  setInputFiles: AudioInputState["setInputFile"][];
  presentation: React.ReactNode;
  currentAudioLengthS: number;
  multipleFiles: boolean;
  maxMultiAudioLengthMinutes: number | null;
  empty: boolean;
}) {
  return (
    <>
      {empty ?
        <InputMethods
          user={user}
          checkSubscription={checkSubscription}
          audioContext={audioContext}
          audioLengthMinLimitMinutes={audioLengthMinLimitMinutes}
          audioLengthMaxLimitMinutes={audioLengthMaxLimitMinutes}
          showRecorder={showRecorder}
          showSelectCoverText={showSelectCoverText}
          adjustAcoustic={adjustAcoustic}
          showCover={showCover}
          setInputFiles={setInputFiles}
          setInputCover={setInputCover}
          currentAudioLengthS={currentAudioLengthS}
          multipleFiles={multipleFiles}
          maxMultiAudioLengthMinutes={maxMultiAudioLengthMinutes}
        />
      : presentation}
    </>
  );
}
